/**
 * Product image hover-magnify.
 * Adds a "loupe" style magnifier that follows the cursor when hovering
 * over the product image — separate from, and fully compatible with,
 * the existing click-to-open zoom modal.
 *
 * Requires: data-zoom-image="<high-res image url>" on each
 * `.product-media__slider-slide--zoom` slide (added in product-media.liquid).
 */
(function () {
	"use strict";

	var ZOOM_FACTOR = 2.5; // how much the lens magnifies
	var LENS_SIZE = 180; // px, square lens size

	// Only run on real mice / trackpads — never on touch devices.
	var supportsHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
	if (!supportsHover) {
		return;
	}

	function isZoomModalOpen() {
		var modal = document.querySelector("[data-zoom-modal].is-active");
		return !!modal;
	}

	function setupSlide(slide) {
		if (slide.dataset.magnifyInit) {
			return;
		}

		var zoomSrc = slide.dataset.zoomImage;
		if (!zoomSrc) {
			return;
		}

		slide.dataset.magnifyInit = "true";
		slide.classList.add("js-magnify-slide");

		var lens = document.createElement("div");
		lens.className = "image-magnify-lens";
		lens.style.backgroundImage = "url(" + zoomSrc + ")";
		lens.style.width = LENS_SIZE + "px";
		lens.style.height = LENS_SIZE + "px";
		slide.appendChild(lens);

		var rect = null;

		function updateRect() {
			rect = slide.getBoundingClientRect();
		}

		function updateLens(event) {
			if (!rect) {
				updateRect();
			}

			var x = event.clientX - rect.left;
			var y = event.clientY - rect.top;

			var clampedX = Math.max(0, Math.min(x, rect.width));
			var clampedY = Math.max(0, Math.min(y, rect.height));

			var lensX = Math.max(0, Math.min(clampedX - LENS_SIZE / 2, rect.width - LENS_SIZE));
			var lensY = Math.max(0, Math.min(clampedY - LENS_SIZE / 2, rect.height - LENS_SIZE));
			lens.style.left = lensX + "px";
			lens.style.top = lensY + "px";

			var scaledWidth = rect.width * ZOOM_FACTOR;
			var scaledHeight = rect.height * ZOOM_FACTOR;
			lens.style.backgroundSize = scaledWidth + "px " + scaledHeight + "px";

			var bgX = -(clampedX * ZOOM_FACTOR - LENS_SIZE / 2);
			var bgY = -(clampedY * ZOOM_FACTOR - LENS_SIZE / 2);
			lens.style.backgroundPosition = bgX + "px " + bgY + "px";
		}

		function onEnter(event) {
			if (isZoomModalOpen() || window.innerWidth < 1200) {
				return;
			}
			updateRect();
			lens.style.display = "block";
			updateLens(event);
		}

		function onMove(event) {
			if (lens.style.display !== "block") {
				return;
			}
			updateLens(event);
		}

		function onLeave() {
			lens.style.display = "none";
		}

		function onDown() {
			// A click opens the existing zoom modal — hide the lens immediately
			// so the two interactions never visually overlap.
			lens.style.display = "none";
		}

		slide.addEventListener("mouseenter", onEnter);
		slide.addEventListener("mousemove", onMove);
		slide.addEventListener("mouseleave", onLeave);
		slide.addEventListener("mousedown", onDown);
	}

	function initMagnify() {
		var slides = document.querySelectorAll(
			"[data-zoom-container] .product-media__slider-slide--zoom[data-zoom-image]"
		);
		slides.forEach(setupSlide);
	}

	function hideAllLenses() {
		document.querySelectorAll(".image-magnify-lens").forEach(function (lens) {
			lens.style.display = "none";
		});
	}

	document.addEventListener("DOMContentLoaded", initMagnify);
	document.addEventListener("shopify:section:load", initMagnify);

	// Hide the lens the moment the click-to-zoom modal opens, and re-scan
	// for new slides (variant image swaps, carousel re-renders, etc.).
	if (window.themeCore && window.themeCore.EventBus) {
		window.themeCore.EventBus.listen("product:zoom:open", hideAllLenses);
	}

	// Re-init periodically covers cases where slides are added dynamically
	// (e.g. variant change swaps media) without a dedicated event to hook.
	var mo = new MutationObserver(function () {
		initMagnify();
	});
	document.addEventListener("DOMContentLoaded", function () {
		var target = document.querySelector("[data-zoom-container]");
		if (target) {
			mo.observe(target, { childList: true, subtree: true });
		}
	});
})();
